import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

// Create a context
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  // Check for token in localStorage on app load
  useEffect(() => {
    // Check if the token exists in localStorage on app load
    const token = localStorage.getItem('token');
    if (token) {
      const name = localStorage.getItem('name');
      const email = localStorage.getItem('email');
      const role = localStorage.getItem('role');
      const permissions = localStorage.getItem('permissions');
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setIsAuthenticated(true);
      setUser({ name, email, role, permissions: permissions ? JSON.parse(permissions) : null });
    }
    setLoading(false); // Set loading to false after checking localStorage
  }, []);

  // Login function to save token and update auth status
  const login = (user_id, token, first_name, last_name, email, username, role, permissions) => {
    localStorage.setItem('user_id', user_id);
    localStorage.setItem('token', token);
    localStorage.setItem('name', first_name + " " + last_name);  // Store name
    localStorage.setItem('username', username);  // Store name
    localStorage.setItem('email', email);  // Store email
    localStorage.setItem('role', role);  // Store role (1 = Admin, 2 = Staff)
    // null/undefined permissions means "no restriction" - store as null, not []
    if (permissions) {
      localStorage.setItem('permissions', JSON.stringify(permissions));
    } else {
      localStorage.removeItem('permissions');
    }
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setIsAuthenticated(true);
    setUser({ first_name, email, role, permissions: permissions || null });
  };

  // Logout function to clear token and update auth status
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('role');
    localStorage.removeItem('permissions');
    delete axios.defaults.headers.common['Authorization'];
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
